import React, { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import ButtonLayout from "../../common/layoutButton";
import images from "../../themes/appImage";
import appconstants from "../../themes/appconstant";
import { useDispatch } from "react-redux";
import { otpLoad, signUpLoad } from "../../redux/slices/auth.slice";
import { useLocation } from "react-router-dom";

const OtpScreen = ({ route }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");

  const [timer, setTimer] = useState(30); // 30-second timer
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const dispatch = useDispatch();

  // ---------------- TIMER LOGIC --------------------
  useEffect(() => {
    let interval;

    if (timer > 0) {
      setIsResendEnabled(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsResendEnabled(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleResend = () => {
    if (!isResendEnabled) return;

    setOtp(["", "", "", "", "", ""]);
    inputRefs.current[0]?.focus();

    setTimer(30);

    const newPayload = {
      email: email,
      isResend: true,
      deviceType: "web",
    };
    dispatch(signUpLoad(newPayload));
  };

  // --------------- OTP INPUT HANDLERS ----------------
  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = () => {
    const finalOtp = otp.join("");
    if (finalOtp.length === 6) {
      dispatch(
        otpLoad({
          email: email,
          deviceType: "web",
          otp: finalOtp,
          reqType: "verify",
        })
      );
    }
  };

  return (
    <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between">
      <div className="min-w-[350px] max-w-[424px] m-auto flex items-center flex-col mt-5">
        <img className="mb-5" src={images.appLogo} alt="metafit-logo" />

        <div className="w-full bg-white border shadow-metafit-shadow rounded-lg p-6">
          <div className="text-2xl font-semibold text-dark text-center my-6">
            {`Enter OTP for ${email}`}
          </div>

          {/* OTP INPUTS */}
          <div className="flex justify-between gap-3 mb-8">
            {otp.map((digit, index) => (
              <Input
                key={index}
                maxLength={1}
                value={digit}
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className="!w-[48px] !h-[48px] !text-center !text-xl 
                           !border-gray-300 !rounded-lg 
                           focus:!border-gray-500 focus:!shadow-none"
              />
            ))}
          </div>

          {/* VERIFY BUTTON */}
          <div className="mb-5">
            <ButtonLayout text="Verify OTP" onClick={handleSubmit} />
          </div>

          {/* RESEND OTP WITH TIMER */}
          <div className="text-center text-sm font-medium text-[#2F2F2FCC] mt-4">
            Didn’t receive OTP?{" "}
            <button
              className={`underline ${
                isResendEnabled
                  ? "text-blue-500 cursor-pointer"
                  : "text-gray-400 cursor-not-allowed"
              }`}
              onClick={handleResend}
              disabled={!isResendEnabled}
            >
              Resend
            </button>
            {/* Timer */}
            {!isResendEnabled && (
              <span className="ml-2 text-dark">({timer}s)</span>
            )}
          </div>
        </div>
      </div>

      <div className="text-sm font-normal text-light mb-3">
        {appconstants.metafitRights}
      </div>
    </div>
  );
};

export default OtpScreen;
